import angular from 'angular';
import {
  pmDataService,
  loaderService,
  ssDialogService, pmSharedModelService,
} from 'app/services';

import SyncableBatchChangeController from './syncable-batch-change.controller';
import SyncableBatchChangeDirective from './syncable-batch-change.directive';

export default angular.module('app.components.advisory.policyManagement.syncBatchChange', [
  pmDataService,
  loaderService,
  ssDialogService, pmSharedModelService,
])
  .directive('syncableBatchChange', SyncableBatchChangeDirective)
  .controller('SyncableBatchChangeController', SyncableBatchChangeController)
  .name;
console.log('app.components.advisory.policyManagement.syncBatchChange');
